import 'bootstrap';
import Backbone from 'backbone';
import dustjs from 'dustjs';
import { ShoppingListSelectorView } from 'views/store/common/projects/shopping_list_selector';
import CartItemModel from 'models/store/client/cart/item';
import _addToProjectButtonDust from 'store/global/common/projects/add_to_project_button.dust';
import 'store/global/components/dropdown_button/dropdown_button.dust';
import { dynamicYield } from '../../../../dynamic_yield_utils';
import { format } from 'date-fns';
import ShoppingListModel from 'app/models/store/client/projects/save_shopping_list';

export const AddToTypes = {
	CART: 'cart',
	PRODUCT: 'product',
	ORDER: 'order'
};
// @Deprecated replaced by add_to_project_handler and add_to_project_instance
export const AddToProjectView = Backbone.View.extend({
	el: '.js-add-to-project-widget',

	events: {
		'click .js-add-to-project-button': 'showShoppingListSelector',
		'click .js-quick-add': 'quickAddProduct'
	},

	initialize: function(options = {}) {
		this.canShowSelectorHook = options.canShowSelectorHook;
		this.hasPreSaveBlocker = options.hasPreSaveBlocker;
		this.preSaveBlocker = options.preSaveBlocker;
		this.getDecoratedSaveData = options.getDecoratedSaveData;
		this.postSuccessHook = options.postSuccessHook;
		this.addToType = options.addToType || AddToTypes.PRODUCT;
		this.quickAddInfo = options.quickAddInfo;
		this.hideGroups = options.hideGroups;

		if (this.addToType === AddToTypes.ORDER) {
			this.orderNumber = options.orderNumber;
		}

		this.shoppingListSelector = new ShoppingListSelectorView({
			hideGroups: this.hideGroups
		});
		this.shoppingListSelector.appendTo(this);

		this.$successBox = this.$('.js-success-box');
		this.$content = this.$('.js-widget-content');
		this.$buttonwrapper = this.$('.js-add-to-project-button-wrapper');
		this.listenTo(this.shoppingListSelector, 'listSelected', this.handleListSelected);
		this.listenTo(Backbone, 'body:click', (e) => {
			if (!this.$el.find(e.target).length && this.shoppingListSelector && this.shoppingListSelector.isVisible()) {
				this.shoppingListSelector.reset();
			}
		});
		this._showReqRecNotification();
	},
	_showReqRecNotification: function() {
		const notification = localStorage.getItem('reqRecNotification');
		if (notification) {
			window.BCOM.notifications.render(notification, 'success');
			localStorage.removeItem('reqRecNotification');
		}
	},
	canShowShoppingListSelector: function() {
		return (this.canShowSelectorHook && this.canShowSelectorHook()) || !this.canShowSelectorHook;
	},
	showShoppingListSelector: function() {
		if (!window.dataLayer.isLoggedIn) {
			Backbone.trigger('omniture:projects', 'atp', 'save_guest');
		}
		if (!this.canShowShoppingListSelector()) {
			return false;
		}
		Backbone.trigger('omniture:projects', 'atp', 'save_logged_in');
		this.shoppingListSelector.show();
	},
	showProjectNotification: function(project) {
		const htmlString = `
			<div class="w-100">
				<p class="b mb0">Saved to ${project.name}!</p>
				<a href="/account/projects/${project.id}/feed" class="pl1 underline theme-success pointer">Go to Project</a>
			</div>
		`;
		window.BCOM.notifications.render(htmlString, 'success');
	},
	showSuccess: function() {
		this.$el.removeClass('is-loading');
		this.$successBox.removeClass('dn').addClass('flex');
		this.$content.addClass('dn');
		setTimeout(this.hideSuccess.bind(this), 3000);
	},
	hideSuccess: function() {
		this.$successBox.addClass('dn').removeClass('flex');
		this.$content.removeClass('dn');
	},
	handleListSelected: function(project) {
		this.$el.addClass('is-loading');
		const { selectedGroup, id, name } = project;
		if (this.addToType === AddToTypes.CART && window.dataLayer.addCartToProjectFeature) {
			window.dataLayer.currentProject = {
				id,
				name
			};
			$.ajax({
				type: 'POST',
				url: '/app/api/projectname',
				data: {
					projectId: id,
					projectName: name
				}
			});
			this.preSaveHook(null, project);
		} else {
			const sessionCartId = selectedGroup.sessionCartId;
			this.preSaveHook(sessionCartId, project);
		}
	},
	setRecentProject(projectId) {
		return $.ajax({
			url: `${window.BCOM.apiPathPrefix}/project/${projectId}/setrecent`,
			method: 'POST'
		}).then((recentProject) => {
			let recentProjectViewParams = { recentProject };
			this.renderButton(recentProjectViewParams);
		});
	},
	renderButton(viewParams) {
		const params = {
			...viewParams
		};
		if (this.addToType === AddToTypes.CART || this.addToType === AddToTypes.ORDER) {
			Object.assign(params, {
				addType: this.addToType
			});
		}
		dustjs.render(_addToProjectButtonDust, params, (err, out) => {
			if (err) {
				return window.clientErrorHandler(err);
			}
			this.$buttonwrapper.html(out);
		});
	},
	quickAddProduct: function() {
		if (!this.canShowShoppingListSelector()) {
			return false;
		}
		Backbone.trigger('omniture:projects', 'atp', 'save_1click');
		this.$el.addClass('is-loading');
		this.preSaveHook(null, null, true);
	},
	preSaveHook(sessionCartId, project, isProjectsQuickAdd = false) {
		if (this.addToType === AddToTypes.PRODUCT) {
			if (isProjectsQuickAdd) {
				window.localStorage.setItem(
					'projectsQuickAddSource',
					JSON.stringify({
						type: this.quickAddInfo.type,
						name: this.quickAddInfo.displayName,
						url: window.location.href
					})
				);
			}
			if (this.hasPreSaveBlocker && this.hasPreSaveBlocker()) {
				return this.preSaveBlocker([sessionCartId], null, isProjectsQuickAdd);
			}
		}
		this.saveToProject(project, sessionCartId, isProjectsQuickAdd);
	},
	saveToProject: function(project, sessionCartId, isProjectsQuickAdd) {
		if (this.addToType === AddToTypes.CART) {
			this.saveCartToShoppingList(project).then((response) => {
				this.handleCartAddedSuccess(response, project);
			});
		} else if (this.addToType === AddToTypes.ORDER) {
			this.saveOrderToShoppingProject(project).then(() => {
				this.handleSuccess(null, null, project);
			});
		} else {
			this.saveItemToShoppingList(sessionCartId, isProjectsQuickAdd).then((response) => {
				if (!project) {
					project = {
						id: $('.js-dropdown-button-text:first-child').attr('data-recent-project-id'),
						name: $('.js-quick-add').text()
					};
				}
				this.handleProductAddedSuccess(response, project);
				this.showProjectNotification(project);
			});
		}
	},
	saveCartToShoppingList: function(project) {
		const shoppingListModel = new ShoppingListModel({
			name: `Saved cart from ${format(new Date(), 'LL/dd/yyyy hh:mm a')}`,
			projectId: project.id
		});
		return shoppingListModel.save();
	},
	saveOrderToShoppingProject: function(project) {
		return $.ajax({
			url: `/app/api/v2/attachOrders/${project.id}`,
			method: 'POST',
			data: {
				orders: [{ orderNumber: this.orderNumber }]
			}
		});
	},
	saveItemToShoppingList: function(sessionCartId, isProjectsQuickAdd = false) {
		const cartItemModel = new CartItemModel(
			Object.assign(this.getDecoratedSaveData(), {
				sessionCartId,
				isProjectsQuickAdd
			})
		);
		return cartItemModel.save();
	},
	handleProductAddedSuccess: function(response, project) {
		const items = response.items || response.sessionCart,
			item = items[0],
			sessionCartId = response.sessionCartId,
			cartItemId = item.id;
		const {
			product: { selectedFinish }
		} = item;
		dynamicYield.trackEvent.addToProject(selectedFinish.uniqueId);
		this.handleSuccess([sessionCartId], cartItemId, project);
	},
	handleSuccess: function(sessionCartId, cartItemId, project) {
		let setRecentProjectPromise = null;
		if (project && project.id) {
			setRecentProjectPromise = this.setRecentProject(project.id);
		}
		return Promise.all([setRecentProjectPromise]).then(() => {
			(this.postSuccessHook && this.postSuccessHook([sessionCartId], [cartItemId], null, project)) || this.showSuccess();
		});
	},
	handleCartAddedSuccess: function(response, project) {
		if (response.id) {
			this.mergeShoppingList(response.cartId, project);
		} else {
			if (!(response.err && response.err.message && response.err.message.indexOf('PROJECT-13') !== -1)) {
				window.BCOM.notifications.render('Sorry, something went wrong, refresh the page and try again.', 'danger');
			}
		}
	},
	mergeShoppingList: function(sessionCartId, project) {
		const data = {
			toSessionCartId: sessionCartId,
			fromSessionCartId: window.dataLayer.cart ? window.dataLayer.cart.sessionCartId : window.dataLayer.sessionCartId,
			projectSessionCartId: sessionCartId,
			projectId: project.id
		};
		return $.ajax({
			url: '/app/api/shoppinglists/mergeCarts',
			method: 'POST',
			data: data
		}).then(() => {
			this.handleSuccess([sessionCartId], null, project);
		});
	}
});
